import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes, AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import * as asn1js from "asn1js";
export const id_lei = "1.3.6.1.4.1.52266.1";
let Lei = class Lei {
    constructor(params = {}) {
        this.leiCode = "";
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: asn1js.PrintableString })
], Lei.prototype, "leiCode", void 0);
__decorate([
    AsnProp({ type: asn1js.PrintableString, context: 0, optional: true })
], Lei.prototype, "leiRole", void 0);
Lei = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], Lei);
export { Lei };
let BaseLeiChoice = class BaseLeiChoice {
    get text() {
        if (this.bmpString !== undefined) {
            return this.bmpString;
        }
        if (this.ia5String !== undefined) {
            return this.ia5String;
        }
        if (this.printableString !== undefined) {
            return this.printableString;
        }
        if (this.utf8String !== undefined) {
            return this.utf8String;
        }
        if (this.visibleString !== undefined) {
            return this.visibleString;
        }
        return undefined;
    }
    set text(value) {
        this.printableString = value;
    }
    constructor(value) {
        if (value) {
            this.text = value;
        }
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], BaseLeiChoice.prototype, "ia5String", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.VisibleString })
], BaseLeiChoice.prototype, "visibleString", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.BmpString })
], BaseLeiChoice.prototype, "bmpString", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Utf8String })
], BaseLeiChoice.prototype, "utf8String", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.PrintableString })
], BaseLeiChoice.prototype, "printableString", void 0);
BaseLeiChoice = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], BaseLeiChoice);
export { BaseLeiChoice };
let LeiChoice = class LeiChoice extends BaseLeiChoice {
    constructor(value) {
        super();
        if (typeof value === "string") {
            this.text = value;
        }
        else if (value instanceof Lei) {
            this.struct = value;
        }
    }
};
__decorate([
    AsnProp({ type: Lei })
], LeiChoice.prototype, "struct", void 0);
LeiChoice = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], LeiChoice);
export { LeiChoice };
export const id_role = "1.3.6.1.4.1.52266.2";
let LeiRole = class LeiRole extends BaseLeiChoice {
};
LeiRole = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], LeiRole);
export { LeiRole };
